import React from "react";
import styled from "styled-components";
import { STATES } from "../../util/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Section = styled.div`
  margin-bottom: 24px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
`;

const SectionHeader = styled.div`
  background: #195174;
  color: white;
  padding: 12px 16px;
  font-size: 1.2rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  td, th { padding: 12px 16px; vertical-align: top; }
  h2 { margin: 0 0 8px; color: #195174; }
  small { color: #555; }
`;

const Select = styled.select`
  width: 100%; max-width: 300px;
  padding: 8px;
  border: 1px solid #195174;
  border-radius: 4px;
`;

const Input = styled.input`
  width: 100%; max-width: 300px;
  padding: 8px;
  padding-right: 2.5em;
  border: 1px solid #195174;
  border-radius: 4px;
`;

const SmallInput = styled(Input)`
  max-width: 120px;
  padding-right: 8px;
`;

const Error = styled.div`
  color: #c00;
  margin-top: 4px;
  font-size: 0.9rem;
`;

export default function PersonalInformation({ 
  data, onChange, errors, showPwd, toggleShowPwd 
}) {
  return (
    <Section>
      <SectionHeader>
        Personal Information –{" "}
        <a
          href="https://isafeventures.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#fff", textDecoration: "underline" }}
        >
          Privacy Policy
        </a>
      </SectionHeader>
      <Table>
        <tbody>
          {/* Title */}
          <tr>
            <td width="30%"><label>Title</label></td>
            <td>
              <Select name="title" value={data.title} onChange={onChange}>
                <option value="" />
                {["Brother","Dr.","Miss","Mr.","Mrs.","Ms.","Pastor","Reverend","Sister"]
                  .map(o => <option key={o} value={o}>{o}</option>)}
              </Select>
            </td>
          </tr>

          {/* First & Last Name */}
          {[
            ["first_name","First Name"],
            ["last_name","Last Name"]
          ].map(([f,label])=>(
            <tr key={f}>
              <td><label>{label}*</label></td>
              <td>
                <Input name={f} value={data[f]} onChange={onChange} />
                {errors[f] && <Error>{errors[f]}</Error>}
              </td>
            </tr>
          ))}

          {/* Address */}
          {[
            ["street","Address*"],
            ["street2","Address 2"]
          ].map(([f,label])=>(
            <tr key={f}>
              <td><label>{label}</label></td>
              <td>
                <Input name={f} value={data[f]} onChange={onChange} />
                {errors[f] && <Error>{errors[f]}</Error>}
              </td>
            </tr>
          ))}

          {/* City */}
          <tr>
            <td><label>City*</label></td>
            <td>
              <Input name="city" value={data.city} onChange={onChange} />
              {errors.city && <Error>{errors.city}</Error>}
            </td>
          </tr>

          {/* State + ZIP */}
          <tr>
            <td><label>State &amp; ZIP*</label></td>
            <td style={{ display: "flex", gap: "8px" }}>
              <Select name="state" value={data.state} onChange={onChange}>
                <option value="">Select a state</option>
                {Object.entries(STATES).map(
                  ([k,v]) => <option key={v} value={v}>{k}</option>
                )}
              </Select>
              <SmallInput
                name="zip"
                placeholder="ZIP"
                value={data.zip}
                onChange={onChange}
              />
            </td>
          </tr>
          {errors.state && <tr><td/><td><Error>{errors.state}</Error></td></tr>}
          {errors.zip   && <tr><td/><td><Error>{errors.zip}</Error></td></tr>}

          {/* Phone / Ext / Fax on one line */}
          <tr>
            <td><label>Phone / Ext / Fax</label></td>
            <td style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <SmallInput
                name="phone"
                placeholder="Phone*"
                value={data.phone}
                onChange={onChange}
              />
              <SmallInput
                name="ext"
                placeholder="Ext"
                value={data.ext}
                onChange={onChange}
              />
              <SmallInput
                name="fax"
                placeholder="Fax"
                value={data.fax}
                onChange={onChange}
              />
            </td>
          </tr>
          {errors.phone && <tr><td/><td><Error>{errors.phone}</Error></td></tr>}

          {/* Email & Confirm */}
          {[
            ["email","Email*"],
            ["confirm_email","Confirm Email*"]
          ].map(([f,label])=>(
            <tr key={f}>
              <td><label>{label}</label></td>
              <td>
                <Input
                  type="email"
                  name={f}
                  value={data[f]}
                  onChange={onChange}
                />
                {errors[f] && <Error>{errors[f]}</Error>}
              </td>
            </tr>
          ))}

          {/* Account Info */}
          <tr>
            <td colSpan="2">
              <h2 style={{ color:"#195174", margin:"16px 0 8px" }}>
                Account Info
              </h2>
            </td>
          </tr>
          {["password","confirm_password"].map(f=>(
            <tr key={f}>
              <td><label>{f==="password"?"Password*":"Confirm Password*"}</label></td>
              <td style={{ position:"relative" }}>
                <Input
                  type={showPwd ? "text" : "password"}
                  name={f}
                  value={data[f]}
                  onChange={onChange}
                />
                <span
                  onClick={toggleShowPwd}
                  style={{
                    position: "absolute",
                    right: "330px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer"
                  }}
                >
                  <FontAwesomeIcon icon={showPwd ? faEyeSlash : faEye} />
                </span>
                {errors[f] && <Error>{errors[f]}</Error>}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Section>
  );
}
